import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { OcbDays } from '@app/core';
import { TranslateService } from '@ngx-translate/core';
import { DxSelectBoxComponent } from 'devextreme-angular';

@Component({
    selector: 'app-day-picker',
    templateUrl: './day-picker.component.html',
    styleUrls: ['./day-picker.component.scss'],
})
export class DayPickerComponent {

    @Input()
    public selectedItem: string;

    @Input()
    public isRequired: boolean = false;

    @Output()
    public selectedItemChange = new EventEmitter<string>();

    @ViewChild(DxSelectBoxComponent)
    public selectBox: DxSelectBoxComponent;

    public days: any[] = new Array<any>();
    public loading: boolean = true;

    constructor(private translateService: TranslateService) {
        this.translateService.get('days').subscribe(labels => {
            for (const day in OcbDays) {
                if (isNaN(Number(day))) {
                    this.days.push({ name: labels[day], id: OcbDays[day] });
                }
            }
            this.loading = false;
        });
    }

    public onSelectedItemChange($event: { name: string, id: string }) {
        if ($event == null) {
            return;
        }
        this.selectedItemChange.emit($event.id);
    }
}
